import UIWidgetsCustomCheckbox from "./Checkbox";
import CheckboxContainer from "./styles";

export default function CustomCheckbox({
  id, name, disabled, readOnly, tabIndex, onFocus, onBlur, autoFocus,
  value, custom, checked, onChange, onClick, saveInput, background
}) {
  return (
    <CheckboxContainer>
      <UIWidgetsCustomCheckbox
        id={id}
        name={name}
        readOnly={readOnly}
        disabled={disabled}
        tabIndex={tabIndex}
        checked={!!checked}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        onClick={onClick}
        autoFocus={autoFocus}
        ref={saveInput}
        value={value}
        background={background}
      />
      {checked ? <div>&#10003;</div> : <div />}
    </CheckboxContainer>
  );
}
